module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco-amazon-connect-chat-widget-small-9a6b7fdb0b45eba4c25e00dcc474a8c2.jpg";